export const APP_NAME = 'sparqle';
export const TOKEN_NAME = process.env.REACT_APP_TOKEN_NAME || '_ovo_session';

export const TIME_FORMAT = 'HH:mm';
export const DAYTIME_FORMAT = 'ddd, MMM Do, YYYY - HH:mm';
export const DAY_FORMAT = 'ddd, MMM Do, YYYY';
export const FULL_DATE_FORMAT = 'ddd, MMM Do, YYYY';
export const DATE_BACKEND_FORMAT = 'YYYY-MM-DD';

export const PAGE_SIZE = 15;

export const PAGE_SIZE_OPTIONS = [PAGE_SIZE, 50, 100];

export const HUB_TAG = {
  CITY_HUB: 'City Hub',
  MICRO_HUB: 'Micro Hub',
  NANO_HUB: 'Nano Hub',
  BIKE_PARK: 'Bike Park',
};

export const FLEET_TAG = {
  BIKE: 'Bike',
  // MODULE: "Module",
  // TRAILER: "Trailer",
  VAN: 'Van',
};

export const FLEET_STATUSES = {
  FUNCTIONAL: 'Functional',
  UNFUNCTIONAL: 'Unfunctional',
  MAINTENANCE: 'Maintenance',
};

export const ORDER_STATUSES = {
  ERROR: 'ERROR',
  DRAFT: 'DRAFT',
  GEOCODING: 'GEOCODING',
  UNASSIGNED: 'UNASSIGNED',
  ASSIGNED: 'ASSIGNED',
  UNSCHEDULED: 'UNSCHEDULED',
  GOING_NEXT: 'GOING_NEXT',
  SKIPPED: 'SKIPPED',
  PICKUP_ARRIVED: 'PICKUP_ARRIVED',
  PICKUP_FAILED: 'PICKUP_FAILED',
  COLLECTED: 'COLLECTED',
  IN_TRANSIT: 'IN_TRANSIT',
  DELIVERY_ARRIVED: 'DELIVERY_ARRIVED',
  DELIVERY_FAILED: 'DELIVERY_FAILED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
};

export const ISSUE_TYPES = {
  WRONG_CODE: 'Wrong Code',
  CUSTOMER_REQUEST: 'Customer Request',
  DELIVERY_INFORMATION: 'Delivery Information',
  RETURN_ISSUE: 'Return Issue',
  DELAY: 'Delay',
  WRONG_ADDRESS: 'Wrong Address',
  PRODUCT_DAMAGE: 'Product Damage',
  CLIENT_UNAVAILABLE: 'Client Unavailable',
  PLANNING_ROUTE_ISSUE: 'Planning Route Issue',
  LOCATION_CLOSED_ACCESS_BLOCKED: 'Location Closed',
  TECHNICAL_ISSUE: 'Technical Issue',
  OTHER: 'Other',
};

export const ORDER_STATUSES_FAILED = [
  ORDER_STATUSES.SKIPPED,
  ORDER_STATUSES.PICKUP_FAILED,
  ORDER_STATUSES.DELIVERY_FAILED,
  ORDER_STATUSES.ERROR,
];
export const ORDER_PICKUP_STATUS_COMPLETED = [
  ORDER_STATUSES.COLLECTED,
  ORDER_STATUSES.PICKUP_FAILED,
  ORDER_STATUSES.SKIPPED,
];
export const ORDER_DELIVERY_STATUS_COMPLETED = [
  ORDER_STATUSES.COMPLETED,
  ORDER_STATUSES.DELIVERY_FAILED,
  ORDER_STATUSES.SKIPPED,
  ORDER_STATUSES.PICKUP_FAILED,
];

export const ORDER_STATUSES_DISPLAY = {
  [ORDER_STATUSES.ERROR]: 'Error',
  [ORDER_STATUSES.DRAFT]: 'Draft',
  [ORDER_STATUSES.GEOCODING]: 'Geocoding',
  [ORDER_STATUSES.UNASSIGNED]: 'Unassigned',
  [ORDER_STATUSES.ASSIGNED]: 'Assigned',
  [ORDER_STATUSES.UNSCHEDULED]: 'Unscheduled',
  [ORDER_STATUSES.GOING_NEXT]: 'Going Next',
  [ORDER_STATUSES.SKIPPED]: 'Skipped',
  [ORDER_STATUSES.PICKUP_ARRIVED]: 'Pickup Arrived',
  [ORDER_STATUSES.PICKUP_FAILED]: 'Pickup Failed',
  [ORDER_STATUSES.COLLECTED]: 'Collected',
  [ORDER_STATUSES.IN_TRANSIT]: 'In Transit',
  [ORDER_STATUSES.DELIVERY_ARRIVED]: 'Delivery Arrived',
  [ORDER_STATUSES.DELIVERY_FAILED]: 'Delivery Failed',
  [ORDER_STATUSES.COMPLETED]: 'Completed',
  [ORDER_STATUSES.CANCELLED]: 'Cancelled',
};

export const ORDER_TYPES = {
  STANDARD: 'STANDARD',
  SERVICE: 'SERVICE',
};

export const ORDER_TYPES_DISPLAY = {
  [ORDER_TYPES.STANDARD]: 'Standard',
  [ORDER_TYPES.SERVICE]: 'Service',
};

export const STEP_TYPE = {
  pickup: 'PICKUP',
  delivery: 'DELIVERY',
  driver: 'DRIVER',
  service: 'SERVICE',
};

export const COLORS = [
  'ed8f8f',
  'f284a8',
  'c788d2',
  'aa92d6',
  '959ed5',
  '85c3f8',
  '76cef9',
  '75c4bc',

  'cd2929',
  'd21a55',
  '8321a0',
  '532fa8',
  '1c7de1',
  '00a2b9',
  '007e70',

  'ae1a1a',
  '7d1046',
  '411481',
  '9bd09d',
  '2b1a87',
  '0f3e97',
  '044d90',
  '005559',
  '004438',

  'f2471c',
  'bddd9b',
  'FFA500cd',
  'e2eb91',
  'c8d2d7',
  'ffc575',
  'ffa186',

  'd1c5c1',
  '3b963e',
  'fdd22f',
  'b8c32d',
  'fa8100',
  '826358',
  '859aa4',

  '1a531d',
  '2d5e1c',
  '776c17',
  'f37417',
  'e24700',
  'b72f0f',
  '533830',
  '3c5059',
];

export const COLOR_DEFAULT = '7732EF';

export const STEP_STATUS = {
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
};

export const ACTION_ROUTE = {
  PENDING: 'PENDING',
  START: 'START',
  PAUSE: 'PAUSE',
  RESUME: 'RESUME',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
};

export const ACTION_ROUTE_DISPLAY = {
  [ACTION_ROUTE.PENDING]: 'Pending',
  [ACTION_ROUTE.START]: 'Start',
  [ACTION_ROUTE.PAUSE]: 'Pause',
  [ACTION_ROUTE.RESUME]: 'Resume',
  [ACTION_ROUTE.COMPLETED]: 'Completed',
  [ACTION_ROUTE.CANCELLED]: 'Cancelled',
};
